<template>
  <v-card class="d-flex align-center flex-column pa-4">
    <Subtitle :line-height="20">{{ mainHeader }}</Subtitle>
    <TextBody style="align-self: start" color="primary">{{ hint }}</TextBody>
    <v-tabs :show-arrows="true" class="mt-4" grow>
      <v-tab key="schritt-1" @click="changeImage('schritt-1')">Schritt 1</v-tab>
      <v-tab key="schritt-2" @click="changeImage('schritt-2')">Schritt 2</v-tab>
      <v-tab key="schritt-3" @click="changeImage('schritt-3')">Schritt 3</v-tab>
    </v-tabs>

    <div
      class="pt-2 pb-2 mt-8"
      style="overflow: hidden; width: 100%; height: 500px"
    >
      <v-img height="100%" contain :src="currentImage" />
    </div>
    <Button @click="$emit('forwards')" class="mt-6" :block="true">{{
      forwardsButtonText
    }}</Button>
    <Button
      color="dark-grey"
      @click="$emit('backwards')"
      class="mt-2"
      :block="true"
      v-if="backwardsButtonText"
    >
      {{ backwardsButtonText }}
    </Button>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import Subtitle from "components/UI/Subtitle.vue"
import TextBody from "components/UI/TextBody.vue"
import Button from "components/UI/Button.vue"

export default defineComponent({
  name: "InstallPWAMobileView",
  components: { Button, TextBody, Subtitle },
  props: {
    mainHeader: {
      type: String,
      required: true,
    },
    hint: {
      type: String,
      required: true,
    },
    step1: {
      type: String,
      required: true,
    },
    step2: {
      type: String,
      required: true,
    },
    step3: {
      type: String,
      required: true,
    },
    forwardsButtonText: {
      type: String,
      required: true,
    },
    backwardsButtonText: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      currentImage: this.step1,
    }
  },
  mounted() {
    console.log("mounted called")
  },
  methods: {
    changeImage(tab) {
      switch (tab) {
        case "schritt-1":
          this.currentImage = this.step1
          break
        case "schritt-2":
          this.currentImage = this.step2
          break
        case "schritt-3":
          this.currentImage = this.step3
          break
        default:
          this.currentImage = this.step1
          break
      }
    },
  },
  setup(props, context) {
    return {}
  },
})
</script>
